import { getColorDifference } from "./utils";

class Tooltips {
    constructor() {
        this.buttons = document.getElementsByClassName('tooltiped');
        this.tooltips = [];
        let i = 0;

        this.observer = new MutationObserver(this.onChange.bind(this));
        for (const button of this.buttons) {
            button.index = i;
            button.addEventListener('mouseleave', this.cursorLeave.bind(this));
            button.addEventListener('mouseenter', this.cursorEnter.bind(this));
            this.observer.observe(button, {
                attributes: true,
                attributeFilter: ['class', 'data-tooltip'],
                childList: false,
                characterData: false,
            });
            const div = document.createElement('div');
            div.classList.add('tooltip');
            if (button.classList.contains('tool-right')) {
                div.classList.add('tooltip-right');
            }
            div.textContent = button.dataset.tooltip;
            this.tooltips.push({
                tooltip: div,
                target: button,
                index: i,
                label: button.dataset.tooltip,
                selectedLabel: button.dataset.tooltipselected,
            });
            document.body.appendChild(div);
            i++;
        }
    }

    onChange(event) {
        if (event.length) {
            for (const mutable of event) {
                const target = mutable.target;
                for (const tooltip of this.tooltips) {
                    if (tooltip.target == target) {
                        this.updateTooltipLabel(tooltip.index);
                        break;
                    }
                }
            }
        }
    }

    changeColor(color, complementaryColor) {
        const constrasted = getColorDifference(color, '#ffffff') < 10 ? false : true;
        for (const tooltip of this.tooltips) {
            if (constrasted) {
                tooltip.tooltip.classList.remove('inversed-colors');
            } else {
                tooltip.tooltip.classList.add('inversed-colors');
            }
        }
    }

    cursorLeave(event) {
        this.hideToolTip(event.currentTarget.index);
    }

    cursorEnter(event) {
        if (event.type.indexOf('touch') == -1) {
            this.showToolTip(event.currentTarget.index);
        }
    }

    hideToolTip(index) {
        this.tooltips[index].tooltip.classList.remove('shown');
    }

    updateTooltipLabel(index) {
        if (
            this.tooltips[index].target.classList.contains('selected') &&
            this.tooltips[index].selectedLabel
        ) {
            this.tooltips[index].tooltip.textContent = this.tooltips[
                index
            ].selectedLabel;
        } else {
            this.tooltips[index].label = this.tooltips[index].target.dataset.tooltip;
            this.tooltips[index].tooltip.textContent = this.tooltips[index].label;
        }
    }

    showToolTip(index) {
        this.updateTooltipLabel(index);
        const targetPosition = this.tooltips[index].target.getBoundingClientRect();
        const targetWidth = this.tooltips[index].target.offsetWidth;
        const targetHeight = this.tooltips[index].target.offsetHeight;
        const topOffset = this.tooltips[index].tooltip.classList.contains(
            'tooltip-right'
        )
            ? targetHeight / 2
            : -10;
        const leftOffset = this.tooltips[index].tooltip.classList.contains(
            'tooltip-right'
        )
            ? targetWidth + 10
            : targetWidth / 2;
        this.tooltips[index].tooltip.style.top = `${Math.round(
            targetPosition.top + topOffset
        )}px`;
        this.tooltips[index].tooltip.style.left = `${Math.round(
            targetPosition.left + leftOffset
        )}px`;
        this.tooltips[index].tooltip.classList.add('shown');
    }
}
export default Tooltips;
